import styled from 'styled-components';

const Title = styled.h1`
  ${({ theme }) => theme.fontFamily.mainFont.xLargeExtraBold}
  width: 250px;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.night_blue_1};
  letter-spacing: normal;
  margin: ${({ theme }) => theme.spacing(0, 0, 3)};
`;

export default Title;
